import p5 from "p5";
import { genTokenData, Random } from "./genkitart/src/utils/helpers";
import {
  exportHighResImage,
  CanvasStore,
} from "./genkitart/src/utils/canvasSet";

let tokenData = genTokenData(123);
const maxWidth = document.getElementById("artCanvas").offsetWidth;
const maxHeight = document.getElementById("artCanvas").offsetHeight;
let canvasStore = new CanvasStore({
  scaleOutput: 1,
  aspectRatio: 3 / 4,
  maxHeight: maxHeight,
  maxWidth: maxWidth,
});

const sketch = (p) => {
  const bars = 15;
  const elements = 37;
  let domains;
  const palettes = [
    {
      name: "Jungle",
      colors: ["#E6603C", "#044F59", "#EDA034", "#28614C"],
      stroke: "#2E3138",
      background: "#E6DECF",
    },
    {
      name: "Toys",
      colors: [
        "#E57E7F",
        "#4A4041",
        "#2C547D",
        "#C75454",
        "#EBB95B",
        "#EBA421",
        "#4D6785",
      ],
      stroke: "#2E3138",
      background: "#EDE5D7",
    },
    {
      name: "Cool",
      colors: [
        "#F2C64B",
        "#5A4543",
        "#305F8B",
        "#7FA9C1",
        "#305F8B",
        "#7FA9C1",
        "#305F8B",
        "#7FA9C1",
      ],
      stroke: "#2E3138",
      background: "#EDE5D7",
    },
    {
      name: "Warm",
      colors: [
        "#D94434",
        "#E36639",
        "#D94434",
        "#E36639",
        "#D94434",
        "#E36639",
        "#E08743",
        "#F7AC3E",
        "#EDBA3B",
        "#7FA9C1",
        "#305F8B",
      ],
      stroke: "#2E3138",
      background: "#EDE5D7",
    },
    {
      name: "Red",
      colors: ["#EA3246"],
      stroke: "#2E3138",
      background: "#E6DECF",
    },
    {
      name: "Warm2",
      primaryColors: [
        { color: "#E36639", weight: 0.5 },
        { color: "#F7AC3E", weight: 0.5 },
      ],
      secondaryColors: [
        { color: "#D94434", weight: 0.3 },
        { color: "#E08743", weight: 0.3 },
      ],
      accentColors: [
        { color: "#305F8B", weight: 0.2 },
        { color: "#7FA9C1", weight: 0.2 },
      ],
      stroke: "#2E3138",
      background: "#EDE5D7",
    },
    {
      name: "Jungle",
      primaryColors: [
        { color: "#EDA034", weight: 0.5 },
        { color: "#E6603C", weight: 0.3 },
      ],
      secondaryColors: [{ color: "#28614C", weight: 0.3 }],
      accentColors: [{ color: "#044F59", weight: 0.2 }],
      stroke: "#2E3138",
      background: "#EDE5D7",
    },
  ];

  p.setup = () => {
    let my_Canvas = p.createCanvas(p.windowWidth, p.windowHeight);
    my_Canvas.parent("artCanvas");
    p.colorMode(p.HSB, 360, 100, 100, 100);
    domains = calculateDomains(bars, elements);
  };

  let time = 0;
  p.draw = () => {
    let minDimension = p.min(p.width, p.height);
    let M = minDimension / 1000;
    let R = new Random(tokenData);
    let pal = palettes[5];

    p.background("#EDE8DC");
    p.stroke(pal.stroke);

    for (let domain of domains) {
      for (let element of domain.elements) {
        let midPointY = p.lerp(
          p.lerp(domain.startY, domain.endY, element.range1.rangeStart),
          p.lerp(domain.startY, domain.endY, element.range1.rangeEnd),
          0.5
        );
        let elementY = p.lerp(
          domain.startY,
          domain.endY,
          element.elementStartY
        );
        p.fill("#044F59");
      }
    }

    for (let domain of domains) {
      for (let element of domain.elements) {
        let noiseValue =
          p.noise(time + element.phaseOffset) *
            (element.range1.rangeEnd - element.range1.rangeStart) +
          element.range1.rangeStart;
        let yPos = p.lerp(domain.startY, domain.endY, noiseValue);
        let noiseValueEnd =
          p.noise(time + element.phaseOffset2) *
            (element.range2.rangeEnd - element.range2.rangeStart) +
          element.range2.rangeStart;
        let yPos2 = p.lerp(domain.startY, domain.endY, noiseValueEnd);
        element.noiseOffset += 0.05;
        p.fill(element.color);
        p.noStroke();
        p.beginShape();
        p.vertex(domain.startX, yPos - 5 * M);
        p.vertex(domain.endX, yPos2 - 5 * M);
        p.vertex(domain.endX, yPos2 + 5 * M);
        p.vertex(domain.startX, yPos + 5 * M);
        p.endShape(p.CLOSE);
      }
    }

    time += 0.001;
  };

  p.windowResized = () => {
    p.resizeCanvas(p.windowWidth, p.windowHeight);
    updateDomainSizes();
  };

  p.keyReleased = (event) => {
    if (event.key === "e" || event.key === "E") {
      exportHighResImage(24, 300, p, canvasStore);
    }
  };

  function calculateDomains(bars, elementsPerDomain) {
    let pal = palettes[4];
    let domains = [];
    let barWidth = p.width / bars;
    let totalHeight = p.height;

    for (let i = 0; i < bars; i++) {
      let startX = i * barWidth;
      let endX = startX + barWidth;
      let elements = [];

      for (let j = 0; j < elementsPerDomain; j++) {
        let colorIndex = p.floor(p.random(pal.colors.length));
        let elementColor = pal.colors[colorIndex];
        let elementStartY = (j + 0.5) / elementsPerDomain;

        let range = 0.05;
        let range2 = 0.05;
        let elementEndY = elementStartY;

        elements.push({
          elementStartY: elementStartY,
          elementEndY: elementEndY,
          color: elementColor,
          range1: {
            rangeStart: elementStartY - range,
            rangeEnd: elementStartY + range,
          },
          range2: {
            rangeStart: elementEndY - range2,
            rangeEnd: elementEndY + range2,
          },
          phaseOffset: p.random(0, 100),
          phaseOffset2: p.random(0, 100),
        });
      }

      domains.push({
        startX: startX,
        endX: endX,
        startY: 0,
        endY: totalHeight,
        elements: elements,
      });
    }
    return domains;
  }

  function updateDomainSizes() {
    let barWidth = p.width / bars;
    for (let i = 0; i < domains.length; i++) {
      domains[i].startX = i * barWidth;
      domains[i].endX = (i + 1) * barWidth;
      domains[i].startY = 0;
      domains[i].endY = p.height;
    }
  }
};

new p5(sketch);
